// Navigation copy from daodaofix9.8, isolated from the live tool pages.
export const toolsByLocale = {
  "en": [
    {
      "id": "image-generator",
      "label": "Image Generator",
      "shortDescription": "Turn a creative direction into production-ready image options.",
      "status": "early-access"
    },
    {
      "id": "video-search",
      "label": "Video Search",
      "shortDescription": "Find videos worth studying across the platforms your audience uses.",
      "status": "early-access"
    },
    {
      "id": "video-analysis",
      "label": "Video Analysis",
      "shortDescription": "Turn one reference video into structured creative insight.",
      "status": "early-access"
    },
    {
      "id": "creative-signal-scanner",
      "label": "Creative Signal Scanner",
      "shortDescription": "Rank market patterns worth investigating.",
      "status": "coming-soon"
    },
    {
      "id": "video-breakdown",
      "label": "Video Breakdown",
      "shortDescription": "Map why a reference video works, scene by scene.",
      "status": "coming-soon"
    },
    {
      "id": "script-brief-builder",
      "label": "Script Brief Builder",
      "shortDescription": "Turn evidence into a brief a creator can shoot.",
      "status": "coming-soon"
    },
    {
      "id": "creator-fit-checklist",
      "label": "Creator Fit Checklist",
      "shortDescription": "Match the creative to the right delivery style.",
      "status": "coming-soon"
    }
  ],
  "zh": [
    {
      "id": "image-generator",
      "label": "生图工具",
      "shortDescription": "把创意方向转化为可评审、可交付的图片方案。",
      "status": "early-access"
    },
    {
      "id": "video-search",
      "label": "视频搜索",
      "shortDescription": "在受众使用的平台中找到值得研究的视频。",
      "status": "early-access"
    },
    {
      "id": "video-analysis",
      "label": "视频解析",
      "shortDescription": "把一条参考视频转化为结构化创意洞察。",
      "status": "early-access"
    },
    {
      "id": "creative-signal-scanner",
      "label": "创意信号扫描器",
      "shortDescription": "筛选并排序值得深入研究的市场模式。",
      "status": "coming-soon"
    },
    {
      "id": "video-breakdown",
      "label": "视频拆解",
      "shortDescription": "逐场景解释参考视频为什么有效。",
      "status": "coming-soon"
    },
    {
      "id": "script-brief-builder",
      "label": "脚本 Brief 生成器",
      "shortDescription": "把证据变成创作者可以拍摄的 Brief。",
      "status": "coming-soon"
    },
    {
      "id": "creator-fit-checklist",
      "label": "达人适配清单",
      "shortDescription": "让创意与合适的表达方式匹配。",
      "status": "coming-soon"
    }
  ]
} as const;
